import { baseUrl, handleResponse, handleError, GetHeaders, PostOptions } from "../common/ApiUtils";

const apiUrl = baseUrl + "Utilities/";

export function getRevShareUsageTypes() {
  return fetch(apiUrl + "revshareusagetypes", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getThisWeekInformation() {
  return fetch(apiUrl + "today", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getActiveConsultants() {
  return fetch(apiUrl + "consultants", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getUtilizationRequestStatuses() {
  return fetch(apiUrl + "utilizationRequestStatusList", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getHoursTransactionTypes() {
  return fetch(apiUrl + "hoursTranasactionTypesList", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function cashOutBlackoutIsActive() {
  return fetch(apiUrl + "blackout", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function flipCashOutBlackOut() {
  return fetch(apiUrl + "blackout", PostOptions())
    .then(handleResponse)
    .catch(handleError);
}
